import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const doLogin = async (em, pw) => {
    setBusy(true); setError("");
    try {
      await login(em, pw);
      toast.success("Accesso effettuato");
      navigate("/");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 p-12 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #0ea5e9 0%, transparent 45%), radial-gradient(circle at 80% 70%, #10b981 0%, transparent 40%)" }} />
        <div className="relative flex items-center gap-3">
          <div className="flex items-center justify-center rounded-xl bg-white px-4 py-3 shadow-sm">
            <img src="/sms-logo.jpg" alt="SMS SRL — Servizi Finanziari" className="h-20 w-auto" data-testid="login-logo" />
          </div>
        </div>
        <div className="relative space-y-5">
          <h1 className="font-heading text-4xl font-bold leading-tight">Gestionale Pratiche di Finanziamento</h1>
        </div>
        <p className="relative text-xs text-slate-500">© 2026 FinPractice Pro — Milano</p>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm space-y-8">
          <div className="lg:hidden flex items-center gap-3">
            <div className="flex items-center justify-center rounded-xl bg-white px-3 py-2 border border-border shadow-sm">
              <img src="/sms-logo.jpg" alt="SMS SRL — Servizi Finanziari" className="h-14 w-auto" />
            </div>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-bold">Accedi al gestionale</h2>
            <p className="text-sm text-muted-foreground mt-1">Inserisci le tue credenziali per continuare</p>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); doLogin(email, password); }} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Nome utente / Email</Label>
              <Input id="email" data-testid="login-username-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" required />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" data-testid="login-submit-button" className="w-full" disabled={busy}>
              {busy ? "Accesso…" : "Accedi"}
            </Button>
            <button type="button" onClick={() => navigate("/forgot-password")} className="w-full text-sm text-muted-foreground hover:text-primary text-center" data-testid="forgot-password-link">Password dimenticata?</button>
          </form>
        </div>
      </div>
    </div>
  );
}
